import { BaseItem } from './common';

export enum FeedbackType {
  Positive = 'POSITIVE',
  Negative = 'NEGATIVE',
}

export interface CreateValues {
  previsitFormSetId: string;
  feedback: FeedbackType;
  comment?: string;
}

export type UpdateValues = Partial<Omit<CreateValues, 'previsitFormSetId'>>;

export interface PatientFeedback extends BaseItem, CreateValues {}
